import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-361aee40"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ba-product-data-boost ba-column-title ba-column-relative"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["boost-text ba-text ba-text-right", [{
      editable: $data.isBoostEdit
    }, $data.isBoostEdit && $options.boost == 1 || !$data.isBoostEdit && $props.value == 1 ? 'ba-text-orange' : 'ba-text-blue']]),
    onClick: _cache[0] || (_cache[0] = (...args) => $options.onBoostEdit && $options.onBoostEdit(...args))
  }, " x" + _toDisplayString($data.isBoostEdit ? $options.boost : $options.convertBoost($props.value)), 3), _createElementVNode("div", {
    class: _normalizeClass(["boost-input", {
      visible: $data.isBoostEdit
    }])
  }, [_withDirectives(_createElementVNode("input", {
    ref: "boost",
    type: "text",
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $options.boost = $event),
    class: "ba-text",
    onInput: _cache[2] || (_cache[2] = (...args) => $options.onBoostInput && $options.onBoostInput(...args)),
    onBlur: _cache[3] || (_cache[3] = (...args) => $options.onBoostBlur && $options.onBoostBlur(...args)),
    onKeydown: _cache[4] || (_cache[4] = (...args) => $options.onBoostKeydown && $options.onBoostKeydown(...args))
  }, null, 544), [[_vModelText, $options.boost]])], 2)]);
}